module.exports = __webpack_public_path__ + "legacy-841596a17a7b6d782175e08959e84603.svg";